import { createSelector } from '@reduxjs/toolkit';
import { selectPersonId } from '../userDataSelectors';

const selectMyOrdersData = state => state.myOrders;

export const selectMyOrders = createSelector(
  selectMyOrdersData,
  state => state.data
);

export const selectIsLoading = createSelector(
  selectMyOrdersData,
  state => state.isLoading
);

export const selectCurrentPage = createSelector(
  selectMyOrdersData,
  state => state.pagination.pageNumber || 1
);

export const selectHasMore = createSelector(
  selectMyOrdersData,
  state => state.hasMore
);

export const selectMyOrdersTotalWO = createSelector(
  selectMyOrdersData,
  state => state?.pagination?.totalResults
);

export const selectMyOrdersFilters = () =>
  createSelector(selectPersonId, personId => ({
    personId,
  }));
